import React from "react";
import { createContext, useContext, useState } from "react";

const GlobalContextStep = createContext({
  step: "listPaymentMethods",
  setStep: () => {},
  showModal: false,
  setShowModal: () => {},
  message: "",
  setMessage: () => {},
  status: "",
  setStatus: () => {},
  loading: false,
  setLoading: () => {},
  time: false,
  setTime: () => {},
});

export const GlobalContextProvider = ({ children }) => {
  const [step, setStep] = useState("listPaymentMethods");
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState(3000);

  
  return (
    <GlobalContextStep.Provider
      value={{
        setStep,
        step,
        showModal,
        setShowModal,
        message,
        setMessage,
        status,
        setStatus,
        loading,
        setLoading,
        time,
        setTime
      }}
    >
      {children}
    </GlobalContextStep.Provider>
  );
};

export const useGlobalContextStep = () => useContext(GlobalContextStep);
